var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 14,
    y1: 4,
    y2: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 3,
    y1: 4,
    y2: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 12,
    y1: 12,
    y2: 12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 3,
    y1: 12,
    y2: 12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 16,
    y1: 20,
    y2: 20
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 3,
    y1: 20,
    y2: 20
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    x2: 14,
    y1: 2,
    y2: 6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 8,
    y1: 10,
    y2: 14
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 16,
    y1: 18,
    y2: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e46bf48c0f7e24c8511eccf2bfbff173.svg";
export { ForwardRef as ReactComponent };